import React from 'react';
import { Book, CheckCircle, Shield, FileText, Activity, Users, Lock, AlertTriangle, TrendingUp, Megaphone, MessageSquare, Target } from 'lucide-react';
export function LibraryTeaserSection() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-gray-50 border-t border-gray-100" data-id="element-867">
      <div className="max-w-7xl mx-auto" data-id="element-868">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-869">
          <h2 className="text-sm font-bold tracking-widest text-gray-500 uppercase mb-4 font-sans" data-id="element-870">
            WHAT COULD YOU BUILD?
          </h2>
          <p className="text-3xl md:text-4xl font-['Syne'] font-bold text-black mb-6" data-id="element-871">
            Smart organizations are capturing their
            <br data-id="element-872" />
            institutional intelligence right now.
          </p>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-873">
            Here's what their libraries look like:
          </p>
        </div>

        {/* Library Cards Grid - 3 COLUMNS */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-874">
          {/* Pharma Card */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-875">
            <div className="p-8" data-id="element-876">
              <div className="mb-6" data-id="element-877">
                <h3 className="text-xl font-bold font-['Syne'] text-black" data-id="element-878">
                  PHARMA
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-879">Life Sciences</p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-880">
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-882" />} text="Brand Voice (Consumer)" data-id="element-881" />
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-884" />} text="Brand Voice (HCP)" data-id="element-883" />
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-886" />} text="FDA Promotional Compliance" data-id="element-885" />
                <GuardrailItem icon={<Activity className="w-4 h-4" data-id="element-888" />} text="Adverse Event Protocol" data-id="element-887" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-890" />} text="Clinical Trial Messaging" data-id="element-889" />
                <GuardrailItem icon={<Lock className="w-4 h-4" data-id="element-892" />} text="Patient Privacy (HIPAA)" data-id="element-891" />
                <GuardrailItem icon={<AlertTriangle className="w-4 h-4" data-id="element-894" />} text="Crisis Communication" data-id="element-893" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-896" />} text="Executive Ghostwriting" data-id="element-895" />
                <div className="pl-7 text-sm text-gray-400 font-medium italic" data-id="element-897">
                  ... hundreds more
                </div>
              </div>

              <div className="bg-green-50 border border-green-100 rounded-lg p-4 flex items-center gap-3" data-id="element-898">
                <TrendingUp className="w-5 h-5 text-green-600" data-id="element-899" />
                <span className="text-sm font-medium text-green-800" data-id="element-900">
                  Result: <span className="font-bold" data-id="element-901">7 days → 1 day</span>{' '}
                  approval cycles
                </span>
              </div>
            </div>
          </div>

          {/* Financial Services Card */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-902">
            <div className="p-8" data-id="element-903">
              <div className="mb-6" data-id="element-904">
                <h3 className="text-xl font-bold font-['Syne'] text-black" data-id="element-905">
                  FINANCIAL SERVICES
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-906">
                  Wealth Management
                </p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-907">
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-909" />} text="SEC Compliance (Forward-Looking)" data-id="element-908" />
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-911" />} text="FINRA Social Media" data-id="element-910" />
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-913" />} text="Client Segmentation (HNW vs. Retail)" data-id="element-912" />
                <GuardrailItem icon={<AlertTriangle className="w-4 h-4" data-id="element-915" />} text="Risk Disclosure Language" data-id="element-914" />
                <GuardrailItem icon={<CheckCircle className="w-4 h-4" data-id="element-917" />} text="Fiduciary Standard Adherence" data-id="element-916" />
                <GuardrailItem icon={<TrendingUp className="w-4 h-4" data-id="element-919" />} text="Market Commentary Guardrails" data-id="element-918" />
                <GuardrailItem icon={<Activity className="w-4 h-4" data-id="element-921" />} text="Counterfactual Reasoning" data-id="element-920" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-923" />} text="Annual Review Documentation" data-id="element-922" />
                <div className="pl-7 text-sm text-gray-400 font-medium italic" data-id="element-924">
                  ... hundreds more
                </div>
              </div>

              <div className="bg-green-50 border border-green-100 rounded-lg p-4 flex items-center gap-3" data-id="element-925">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-926" />
                <span className="text-sm font-medium text-green-800" data-id="element-927">
                  Result:{' '}
                  <span className="font-bold" data-id="element-928">Zero compliance incidents</span>{' '}
                 
                </span>
              </div>
            </div>
          </div>

          {/* Marketing & Communications Card */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300" data-id="element-929">
            <div className="p-8" data-id="element-930">
              <div className="mb-6" data-id="element-931">
                <h3 className="text-xl font-bold font-['Syne'] text-black" data-id="element-932">
                  MARKETING
                </h3>
                <p className="text-sm text-gray-500 font-medium" data-id="element-933">
                  Enterprise Brand
                </p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-934">
                <GuardrailItem icon={<Megaphone className="w-4 h-4" data-id="element-936" />} text="Brand Voice Consistency" data-id="element-935" />
                <GuardrailItem icon={<Users className="w-4 h-4" data-id="element-938" />} text="Audience Segmentation (B2B vs. B2C)" data-id="element-937" />
                <GuardrailItem icon={<Shield className="w-4 h-4" data-id="element-940" />} text="Legal Disclaimer Requirements" data-id="element-939" />
                <GuardrailItem icon={<Lock className="w-4 h-4" data-id="element-942" />} text="Competitor Mention Policy" data-id="element-941" />
                <GuardrailItem icon={<MessageSquare className="w-4 h-4" data-id="element-944" />} text="Social Media Guidelines" data-id="element-943" />
                <GuardrailItem icon={<Target className="w-4 h-4" data-id="element-946" />} text="Product Positioning" data-id="element-945" />
                <GuardrailItem icon={<AlertTriangle className="w-4 h-4" data-id="element-948" />} text="Crisis Communication" data-id="element-947" />
                <GuardrailItem icon={<FileText className="w-4 h-4" data-id="element-950" />} text="Executive Ghostwriting" data-id="element-949" />
                <div className="pl-7 text-sm text-gray-400 font-medium italic" data-id="element-951">
                  ... hundreds more
                </div>
              </div>

              <div className="bg-green-50 border border-green-100 rounded-lg p-4 flex items-center gap-3" data-id="element-952">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-953" />
                <span className="text-sm font-medium text-green-800" data-id="element-954">
                  Result: <span className="font-bold" data-id="element-955">100% on-brand</span>{' '}
                  outputs
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Closing */}
        <div className="text-center max-w-3xl mx-auto" data-id="element-956">
          <p className="text-xl md:text-2xl font-light text-gray-800 leading-relaxed font-['Syne']" data-id="element-957">
            You know your regulatory boundaries. You know your brand standards.
            You know what your top performers do differently.
            <br data-id="element-958" />
            <br data-id="element-959" />
            <span className="font-bold text-black" data-id="element-960">
              What if that knowledge was machine-readable?
            </span>
          </p>
        </div>
      </div>
    </section>;
}
function GuardrailItem({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-3 text-gray-700" data-id="element-961">
      <div className="text-gray-400 flex-shrink-0" data-id="element-962">{icon}</div>
      <span className="text-sm font-medium" data-id="element-963">{text}</span>
    </div>;
}